// extracted by mini-css-extract-plugin
module.exports = {"root":"Images90_root__1lmsL","title":"Images90_title__2fDMm","images":"Images90_images__1dcRe"};